export default {
  fi: {
    SideBar: {
      createVehicle: 'Lisää ajoneuvo',
      home: 'Etusivu',
      vehicles: 'Ajoneuvoni',
      reminders: 'Muistutukset',
      settings: 'Asetukset',
      logOut: 'Kirjaudu ulos',
      businessSettings: 'Yrityksen asetukset',
      partnerships: 'Kumppanuudet',
      team: 'Tiimi',
      groups: 'Ryhmät',
      faults: 'Vikailmoitukset',
      order: 'Tilaa',
      feedback: 'Anna palautetta',
      checkLicenses: 'Tarkasta lisenssit',
    },
  },
};
